export async function xhrUpload({
  url,
  file,
  onProgress,
  abortController,
}: {
  url: string
  file: XMLHttpRequestBodyInit
  onProgress?: (progress: number) => void
  abortController?: AbortController
}): Promise<XMLHttpRequest> {
  const xhr = new XMLHttpRequest()

  if (abortController != null) {
    abortController.signal.addEventListener('abort', () => {
      xhr.abort()
    })
  }

  await new Promise<void>((resolve, reject) => {
    // Track progress
    xhr.upload.addEventListener('progress', e => {
      if (e.lengthComputable) {
        onProgress?.(Math.floor((e.loaded / e.total) * 100))
      }
    })

    // Handle upload completion
    xhr.addEventListener('load', () => {
      if (xhr.status >= 200 && xhr.status < 300) {
        resolve()
      } else {
        reject(new Error(`Upload failed: ${xhr.statusText}`))
      }
    })

    // Handle upload errors & cancellations
    xhr.addEventListener('error', reject)
    xhr.addEventListener('abort', reject)

    // Configure request
    xhr.open('PUT', url)
    // Intentionally not configuring other headers as they
    // may invalidate the request signature in url

    // Send the file
    xhr.send(file)
  })

  return xhr
}
